
export function getCoordinates(nestedDiv: any, rootParent: any) {
  let offsetTop = 0;
  let offsetLeft = 0;
  let offsetRight = 0;
  let offsetBottom = 0;
  let currentElement = nestedDiv;

  try {
    while (
      currentElement !== rootParent &&
      currentElement &&
      currentElement.offsetParent
    ) {
      offsetTop += currentElement.offsetTop;
      offsetLeft += currentElement.offsetLeft;
      offsetRight += currentElement.offsetRight;
      offsetBottom += currentElement.offsetBottom;
      currentElement = currentElement.offsetParent;
    }
  } catch (error) {
    console.error("Error occurred while calculating coordinates:", error);
    return { top: 0, left: 0, bottom: 0, right: 0 };
  }

  return { top: offsetTop, left: offsetLeft ,right : offsetRight, bottom : offsetBottom };
}